
if (import.meta.hot) {
  import.meta.hot.accept((mod) => {
    const router = import.meta.hot.data.router
    const generateRoutes = import.meta.hot.data.generateRoutes
    if (!router || !generateRoutes) {
      import.meta.hot.invalidate('[nuxt] Cannot replace routes because there is no active router. Reloading.')
      return
    }
    router.clearRoutes()
    const routes = generateRoutes(mod.default || mod)
    function addRoutes (routes) {
      for (const route of routes) {
        router.addRoute(route)
      }
      router.replace(router.currentRoute.value.fullPath)
    }
    if (routes && 'then' in routes) {
      routes.then(addRoutes)
    } else {
      addRoutes(routes)
    }
  })
}

export function handleHotUpdate(_router, _generateRoutes) {
  if (import.meta.hot) {
    import.meta.hot.data ||= {}
    import.meta.hot.data.router = _router
    import.meta.hot.data.generateRoutes = _generateRoutes
  }
}
import { default as gSe56KFAUmtnrtOZnUq_D3iXEptT_DKPobghqsG0KXBgMeta } from "/codebuild/output/src2333589169/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue?macro=true";
import { default as indexJ28_45DU9AsScByhXgMDIRr7rQU__45UuP9nQqqZ63b4zrAMeta } from "/codebuild/output/src2333589169/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue?macro=true";
import { default as searchs4TgoNEdAmo_AZbRTv85h5BGKFDPU0DJJLa4fTpDvVkMeta } from "/codebuild/output/src2333589169/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue?macro=true";
import { default as indexiDAsEwQMAXtI_45ssPryBobdbKnZArh4_1rmEHvxd0pMwMeta } from "/codebuild/output/src2333589169/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue?macro=true";
import { default as _91id_934EUe2EV98d2lpgsvntkBZlvFKyLQjZlkVqx3ibXKowwMeta } from "/codebuild/output/src2333589169/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue?macro=true";
import { default as indexrm6PUOm3uk0ByH_45qMGJgy6501UI3KJgfifxvzU1OLw4Meta } from "/codebuild/output/src2333589169/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue?macro=true";
import { default as _91id_93PMjgDqGn6w_45hLcO18yvQP2AEQ6XWBTTK8FsJ9AL4vvsMeta } from "/codebuild/output/src2333589169/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue?macro=true";
import { default as indexGgnxpY2rJ6gDvpo1bTlIspsBWL5_RPeo8btTBgSw8v4Meta } from "/codebuild/output/src2333589169/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue?macro=true";
import { default as _91id_93MEbuXHvvr4KxVvUiOLZukB_45SfpKop9ZNcXs9n6LR4sIMeta } from "/codebuild/output/src2333589169/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue?macro=true";
import { default as indexD5Lgry__45mxSz6PriOOSUcK5rK8DRFL2kk16LXO2Ny0oMeta } from "/codebuild/output/src2333589169/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue?macro=true";
import { default as indexHez3Tt_pGcAulFvSSm5J5MCIj08LDa1HFNqXZciyAoMMeta } from "/codebuild/output/src2333589169/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue?macro=true";
export default [
  {
    name: "g",
    path: "/g",
    component: () => import("/codebuild/output/src2333589169/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/g.vue")
  },
  {
    name: "index",
    path: "/",
    component: () => import("/codebuild/output/src2333589169/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/index.vue")
  },
  {
    name: "search",
    path: "/search",
    component: () => import("/codebuild/output/src2333589169/src/actions-runner/_work/onenews/onenews/web-services/common/pages/search.vue")
  },
  {
    name: "v8",
    path: "/v8",
    component: () => import("/codebuild/output/src2333589169/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/index.vue")
  },
  {
    name: "video-id",
    path: "/video/:id()",
    component: () => import("/codebuild/output/src2333589169/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/video/[id].vue")
  },
  {
    name: "terms",
    path: "/terms",
    meta: indexrm6PUOm3uk0ByH_45qMGJgy6501UI3KJgfifxvzU1OLw4Meta || {},
    component: () => import("/codebuild/output/src2333589169/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/terms/index.vue")
  },
  {
    name: "article-id",
    path: "/article/:id()",
    component: () => import("/codebuild/output/src2333589169/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/article/[id].vue")
  },
  {
    name: "contact",
    path: "/contact",
    meta: indexGgnxpY2rJ6gDvpo1bTlIspsBWL5_RPeo8btTBgSw8v4Meta || {},
    component: () => import("/codebuild/output/src2333589169/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/contact/index.vue")
  },
  {
    name: "v8-article-id",
    path: "/v8/article/:id()",
    component: () => import("/codebuild/output/src2333589169/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/v8/article/[id].vue")
  },
  {
    name: "privacy-policy",
    path: "/privacy-policy",
    meta: indexD5Lgry__45mxSz6PriOOSUcK5rK8DRFL2kk16LXO2Ny0oMeta || {},
    component: () => import("/codebuild/output/src2333589169/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/index.vue")
  },
  {
    name: "privacy-policy-relationships",
    path: "/privacy-policy/relationships",
    meta: indexHez3Tt_pGcAulFvSSm5J5MCIj08LDa1HFNqXZciyAoMMeta || {},
    component: () => import("/codebuild/output/src2333589169/src/actions-runner/_work/onenews/onenews/web-services/onenews/pages/privacy-policy/relationships/index.vue")
  }
]